/* eslint-disable  @typescript-eslint/no-explicit-any */

const autoFinHttpMsg: any = {
  '200': {
    message: 'success',
  },
  '204': {
    message: 'no content',
  },
  '400': {
    '4005': {
      message: 'Bad Request',
    },
    '4006': {
      message: 'Bad Request',
    },
    '4003': {
      message: 'Bad Request',
    },
    '4004': {
      message: 'Bad Request',
    },
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '401': {
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '403': {
    '40301601': {
      message: 'El código es incorrecto, inténtalo de nuevo',
    },
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '404': {
    '4040': {
      message: 'Lead not found',
    },
    '4041': {
      message: 'AutoYear not found',
    },
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '409': {
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '412': {
    '4121': {
      message: 'Some preconditions failed',
    },
    '4124': {
      message: 'Some preconditions failed (Lead without personId)',
    },
    '41224': {
      message: 'El enganche tiene que ser mayor al 20% del precio del vehículo',
    },
    '41219603': {
      message: 'El RFC no es válido',
    },
    '41226': {
      message: 'Correo electrónico no valido',
    },
    XXX601: {
      message: 'CHS Integration Error - Third party message',
    },
    default: {
      message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
    },
  },
  '500': {
    default: { message: 'Estamos teniendo problemas Inténtalo más tarde' },
  },
  default: {
    message: '¡Ups!... Ocurrió un error Inténtalo más tarde',
  },
};

export { autoFinHttpMsg };
